import { Box, Select, MenuItem, FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LicenseInformationStyle = styled(Box)(
  ({ theme }) => `

`,
);

export const SelectStyle = styled(Select)(
  ({ theme }) => `
  height: 40px;
  font-size: 18px;
`,
);

export const MenuItemStyle = styled(MenuItem)(
  ({ theme }) => `
  height: 36px;
  
  &.Mui-selected, &.Mui-selected:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`,
);

export const FormErrorText = styled(FormHelperText)(
  ({ theme }) => `
  color: ${theme.palette.errorDark.main};
  margin-left: 14px;
`,
);
